import React from 'react';
import PropTypes from 'prop-types';
import { Input } from '@progress/kendo-react-inputs';
import FormItem from '../components/FormItem';
import { withRouter } from 'react-router';
import isPage from '../hoc/isPage';
import Toolbar from "../components/Toolbar";
import ToolbarOption from '../components/ToolbarOption';
import DropDownContainer from '../components/DropDownContainer';
import { /*getRoleID, */isEmpty } from '../helpers';
import { AppContext } from '../context/AppContext';
//import { domainToASCII } from 'url';

/*
    manageUsersForSelectedOrg
        user - gets passed in
        org - determine from the URL
    manageSuperUsers
        user - gets passed in
        org - does not get passed in
    manageUsersForOwnOrg
        user - get passed in
        org - does not get passed in
*/

class AdminEditUserPage extends React.Component {
    static propTypes = {
        user: PropTypes.shape({
            userID: PropTypes.string
        }),
        handleCloseModal: PropTypes.func.isRequired,
        mode: PropTypes.oneOf([
            "manageUsersForSelectedOrg",
            "manageSuperAdmins",
            "manageUsersForOwnOrg"
        ]),
        role: PropTypes.object,
        org: PropTypes.object
    }
    state = {
        firstName: '',
        lastName: '',
        email: '',

        org: this.props.org,
        roles: this.props.role ? [this.props.role] : [],
        inactive: false,
        sendWelcomeEmail: false,

        // flag gets raised after successful submission happens
        isSubmitted: false
    }
    componentDidMount() {
        const { user } = this.props;
        //console.log('editing', user);
        if (!isEmpty(user)) {

            this.props.getData(`/api/portal/admin/user/${user.userID}/GetUser`)
                .then(({ data }) => {
                    //console.log('retrieved this user data: ', data)

                    // grab all the roles

                    // let role;
                    // if (!isEmpty(data.roles)) {
                    //     role = data.roles[0]
                    // }

                    // populate the fields.
                    this.setState({
                        firstName: data.firstName,
                        lastName: data.lastName,
                        email: data.email,
                        org: { orgID: data.orgID, orgName: data.orgName },
                        roles: data.roles,
                        inactive: data.inactive
                    })
                })
        }
    }

    handleSubmit = () => {

        // POST to /api/portal/admin/user/CreateUser, OR /api/portal/admin/user/UpdateUser

        let apiUrl = '';
        let action = '';
        if (this.props.user) {
            apiUrl = '/api/portal/admin/user/UpdateUser';
            action = 'm0032';
        } else {
            apiUrl = '/api/portal/admin/user/CreateUser';
            action = 'm0033';
        }

        const orgType = this.context.state.orgType;
        const org = this.props.org && orgType !== "dealergroup" ? this.props.org : this.state.org;
        const orgID = org ? org.orgID : null;

        // get form fields
        const { firstName, lastName, email, roles, inactive/*, sendWelcomeEmail*/ } = this.state;

        // validation
        let errorMessage = '';
        if (isEmpty(firstName)) {
            errorMessage = this.props.returnLocalizedString("m0066");
        } else if (isEmpty(lastName)) {
            errorMessage = this.props.returnLocalizedString("m0067");
        } else if (isEmpty(email)) {
            errorMessage = this.props.returnLocalizedString("m0068");
        } else if (isEmpty(roles)) {
            errorMessage = this.props.returnLocalizedString("m0069");
        } else if (isEmpty(orgID)) {
            errorMessage = this.props.returnLocalizedString("m0070");
        }
        if (!isEmpty(errorMessage)) {
            this.props.alert("error", this.props.returnLocalizedString("m0023"), errorMessage);
            return;
        }

        // let roleIDs;
        const user = {
            firstName,
            lastName,
            email,
            orgID,
            roleIDs: roles.map(role => role.roleID)
        }
        if (this.props.user) {
            user["userID"] = this.props.user.userID;
            user["inactive"] = inactive;
        }

        //console.log('posting this ...', user);

        this.props.postData(apiUrl, user).then(response => {
            const { userID } = response.data;
            const uiLanguage = this.props.uiLanguage;

            this.props.successAlert( "m0071", action);

            // update the listing of users.
            this.props.handleRefreshListing();

            // now let's send the welcome email if asked
            if (this.state.sendWelcomeEmail) {
                this.props.postData(`/api/portal/admin/user/${userID}/SendWelcomeEmail?uiLanguage=${uiLanguage}`).then(() => {
                    this.props.alert("info", this.props.returnLocalizedString("m0072"), '🚀 ' + this.props.returnLocalizedString("m0073", "", user.firstName, user.lastName));
                }).catch((error) => {
                    this.props.alert("error", this.props.returnLocalizedString("m0074"), this.props.returnLocalizedString("m0075"))
                })
            }


            this.setState({
                isSubmitted: true
            });
        }).catch(error => {
            this.props.alert("error", this.props.returnLocalizedString("m0023"), `${error.response.data}`)
        })

    }



    handleChange = (e) => {
        //debugger;
        if (["inactive", "sendWelcomeEmail"].includes(e.target.name)) {
            this.setState({
                [e.target.name]: e.target.checked
            })
        } else {
            //debugger;
            this.setState({
                [e.target.name]: e.target.value
            }, () => {
                //debugger;
            })
        }
    }
    renderOrgDropdown() {
        //const { mode } = this.props;
        const orgType = this.context.state.orgType;

        if (this.props.org) {
            if (orgType === "dealergroup") {
                // Set the org of user to the current org if it is to create new user
                if (!(this.state.org))
                    this.setState({
                        org: {
                            orgID: this.context.state.orgID,
                            orgName: this.context.state.orgName
                        }
                    });

                return (
                    <div className="bottom-margin-10">
                        <label htmlFor="org">{this.props.returnLocalizedString("m0084")}</label>
                        {/* <DropDownContainer mode="autocomplete" id="org" name="org" dataType="allOrgs" value={this.state.org} handleChange={this.handleChange} /> */}
                        <DropDownContainer hasEmptyOption={false} required={true} id="org" name="org" dataType="allHierarchyOrgs"
                            uiLanguage={this.props.getLanguage()}
                            handleChange={this.handleChange} value={this.state.org} />
                    </div>
                );
            }
            else
                // show the name of our own org
                return (
                    <div className="bottom-margin-10">
                        <label htmlFor="org">{this.props.returnLocalizedString("m0084")}</label>
                        {this.props.org.orgName}

                    </div>
                );
        } else {
            // superadmin

            // Set the org of user to the current org if it is to create new user
            if (!(this.state.org))
                this.setState({
                    org: {
                        orgID: this.context.state.orgID,
                        orgName: this.context.state.orgName
                    }
                });

            return (
                <div className="bottom-margin-10">
                    <label htmlFor="org">{this.props.returnLocalizedString("m0084")}</label>
                    {/* <DropDownContainer mode="autocomplete" id="org" name="org" dataType="allOrgs" value={this.state.org} handleChange={this.handleChange} /> */}
                    <DropDownContainer hasEmptyOption={false} required={true} id="org" name="org" dataType="allOrgs"
                        uiLanguage={this.props.getLanguage()}
                        handleChange={this.handleChange} value={this.state.org} />
                </div>
            )
        }
    }

    renderRoleDropdown() {

        //const { mode } = this.props;


        // "manageUsersForSelectedOrg",
        // "manageSuperAdmins",
        // "manageUsersForOwnOrg"

        return (
            <div className="bottom-margin-10">
                <label htmlFor="roles">{this.props.returnLocalizedString("m0085")}</label>
                <DropDownContainer required={true} mode="multiselect" id="roles" name="roles" dataType="roles" value={this.state.roles}
                    uiLanguage={this.props.getLanguage()}
                    handleChange={this.handleChange} />
            </div>
        )

    }

    //!DBTRANS! @m0023@ Error! !DEVNOTE! Action status
    //!DBTRANS! @m0032@ updated !DEVNOTE! Action status
    //!DBTRANS! @m0033@ created !DEVNOTE! Action status
    //!DBTRANS! @m0036@ Success! !DEVNOTE! Action status
    //!DBTRANS! @m0066@ You must specify a first name. !DEVNOTE! Form submission error reason
    //!DBTRANS! @m0067@ You must specify a last name. !DEVNOTE! Form submission error reason
    //!DBTRANS! @m0068@ You must specify an email address. !DEVNOTE! Form submission error reason
    //!DBTRANS! @m0069@ You must choose at least one role. !DEVNOTE! Form submission error reason
    //!DBTRANS! @m0070@ You must choose an org. !DEVNOTE! Form submission error reason
    //!DBTRANS! @m0071@ The user was sucessfully %action%! !DEVNOTE! Action status
    //!DBTRANS! @m0072@ Heads up! !DEVNOTE! New user email dialog text
    //!DBTRANS! @m0073@ We have just fired off a welcome email to %var1% %var2%... !DEVNOTE! New user email dialog text
    //!DBTRANS! @m0074@ The email could not be sent off! !DEVNOTE! New user email dialog text
    //!DBTRANS! @m0075@ Close the window and use the Send Welcome Email button. !DEVNOTE! New user email dialog text
    //!DBTRANS! @m0076@ Modify User Record !DEVNOTE! User management page label
    //!DBTRANS! @m0077@ Create User Record !DEVNOTE! User management page label
    //!DBTRANS! @m0078@ First Name !DEVNOTE! Form field
    //!DBTRANS! @m0079@ Last Name !DEVNOTE! Form field
    //!DBTRANS! @m0080@ Email !DEVNOTE! Form field
    //!DBTRANS! @m0081@ Inactive:  !DEVNOTE! Form field
    //!DBTRANS! @m0082@ Send welcome !DEVNOTE! Form field
    //!DBTRANS! @m0083@  email?  !DEVNOTE! Form field
    //!DBTRANS! @m0084@ Org:  !DEVNOTE! Form field
    //!DBTRANS! @m0085@ Role(s):*  !DEVNOTE! Form field


    render() {
        const { user } = this.props;

        // we want to prevent the user from deactivating himself
        const isModifyingOwnUserRecord = (user && (user.userID === this.context.state.userID));

        return (
            <div className="position-relative">
                <div className="k-window-title k-dialog-title padding-bottom-20">
                    {user ? this.props.returnLocalizedString("m0076") : this.props.returnLocalizedString("m0077")}
                </div>
                <Toolbar onEditScrtooltip={true} >
                    {(!this.state.isSubmitted || !isEmpty(this.props.user)) && (<ToolbarOption onEditScrtooltip={true} type="save" handleClick={this.handleSubmit} />)}

                    <ToolbarOption onEditScrtooltip={true} type="close" handleClick={this.props.handleCloseModal} />
                </Toolbar>
                <TextField required={true} name="firstName" label= {this.props.returnLocalizedString("m0078")} value={this.state.firstName} handleChange={this.handleChange} />
                <TextField required={true} name="lastName" label= {this.props.returnLocalizedString("m0079")} value={this.state.lastName} handleChange={this.handleChange} />
                <TextField required={true} name="email" label={this.props.returnLocalizedString("m0080")} value={this.state.email} handleChange={this.handleChange} />

                {this.renderRoleDropdown()}
                {this.renderOrgDropdown()}

                {user && !isModifyingOwnUserRecord && (
                    <div className="bottom-margin-10">
                        <label htmlFor="isInactive">{this.props.returnLocalizedString("m0081")}</label>
                        <input
                            id="inactive"
                            name="inactive"
                            type="checkbox"
                            checked={this.state.inactive === true}
                            onChange={this.handleChange} />
                    </div>
                )}

                {!user && (
                    <div className="bottom-margin-10">
                        <label htmlFor="sendWelcomeEmail">{this.props.returnLocalizedString("m0082")}<br />{this.props.returnLocalizedString("m0083")}</label>
                        <input
                            id="sendWelcomeEmail"
                            name="sendWelcomeEmail"
                            type="checkbox"
                            checked={this.state.sendWelcomeEmail === true}
                            onChange={this.handleChange} />
                    </div>
                )}

            </div>
        );
    }
}

const TextField = ({ name, label, value, handleChange, required = false }) => {
    return (
        <FormItem>
            <label htmlFor={name}>{label}:{required ? '*' : ''} </label>
            <Input id={name} required={required} value={value} onChange={handleChange} name={name} type="text" placeholder={label} />
        </FormItem>
    )
}
export default withRouter(isPage(AdminEditUserPage));
AdminEditUserPage.contextType = AppContext;


// WEBPACK FOOTER //
// ./src/containers/AdminEditUserPage.js